// Auto-generated from answerOptions.csv
// Do not edit manually

import { CSVRow } from '../lib/csvLoader';

export const answerOptionsData: CSVRow[] = [
  {
    "id": "1",
    "label": "Iconic Red",
    "description": "",
    "beautyProfilerAllure": "1",
    "beautyProfilerProducts": "20,23,24,25,28,31,33,34,35,39,40"
  },
  {
    "id": "2",
    "label": "Timeless nude",
    "description": "",
    "beautyProfilerAllure": "2",
    "beautyProfilerProducts": "21,22,26,27,29,30,36"
  },
  {
    "id": "3",
    "label": "Vibrant pink",
    "description": "",
    "beautyProfilerAllure": "3",
    "beautyProfilerProducts": "21,26,30,37,38"
  },
  {
    "id": "4",
    "label": "Warm coral",
    "description": "",
    "beautyProfilerAllure": "4",
    "beautyProfilerProducts": "21,24,27,32,37,39,41"
  },
  {
    "id": "5",
    "label": "Classic stiletto heels",
    "description": "",
    "beautyProfilerAllure": "1",
    "beautyProfilerProducts": ""
  },
  {
    "id": "6",
    "label": "Elegant mocassins",
    "description": "",
    "beautyProfilerAllure": "2",
    "beautyProfilerProducts": ""
  },
  {
    "id": "7",
    "label": "Casual sneakers",
    "description": "",
    "beautyProfilerAllure": "3",
    "beautyProfilerProducts": ""
  },
  {
    "id": "8",
    "label": "Refined sandals",
    "description": "",
    "beautyProfilerAllure": "4",
    "beautyProfilerProducts": ""
  },
  {
    "id": "9",
    "label": "Sexy red lips",
    "description": "",
    "beautyProfilerAllure": "1",
    "beautyProfilerProducts": "20,23,24,25,28,31,33,34,35,39,40"
  },
  {
    "id": "10",
    "label": "Textured matte lips",
    "description": "",
    "beautyProfilerAllure": "2",
    "beautyProfilerProducts": "22,25,26,29,30,32,36,37,38"
  },
  {
    "id": "11",
    "label": "Bold layered lips",
    "description": "",
    "beautyProfilerAllure": "3",
    "beautyProfilerProducts": "24,25,28,33,34,35,39,40"
  },
  {
    "id": "12",
    "label": "Luminous glossy lips",
    "description": "",
    "beautyProfilerAllure": "4",
    "beautyProfilerProducts": "21,22,26,27,29,30,32,37,38,41"
  },
  {
    "id": "13",
    "label": "Sexy empowerment",
    "description": "",
    "beautyProfilerAllure": "1",
    "beautyProfilerProducts": "1,2,5,6,11,14,16,19,20,23,24,25,28,31,33,34,35,40"
  },
  {
    "id": "14",
    "label": "Timeless elegance",
    "description": "",
    "beautyProfilerAllure": "2",
    "beautyProfilerProducts": "1,4,7,11,13,15,20,21,22,25,26,27,29,30,32,33,34,36,37,38,40,41"
  },
  {
    "id": "15",
    "label": "Trendy daring",
    "description": "",
    "beautyProfilerAllure": "3",
    "beautyProfilerProducts": "3,6,8,10,17,18,19,24,31,35,39"
  },
  {
    "id": "16",
    "label": "Effortless chic",
    "description": "",
    "beautyProfilerAllure": "4",
    "beautyProfilerProducts": "2,3,4,9,10,11,12,21,22,26,27,29,30,32,36,37,38,41"
  },
  {
    "id": "17",
    "label": "Glam dinner party",
    "description": "",
    "beautyProfilerAllure": "1",
    "beautyProfilerProducts": "1,2,5,13,14,16,17,18,19,20,22,23,24,25,28,31,33,34,35,38,39,40"
  },
  {
    "id": "18",
    "label": "Brunch at a rooftop",
    "description": "",
    "beautyProfilerAllure": "2",
    "beautyProfilerProducts": "1,2,3,4,6,10,11,12,13,15,21,22,24,25,26,27,28,29,30,32,35,36,37,38,39,41"
  },
  {
    "id": "19",
    "label": "Last minute flight ticket",
    "description": "",
    "beautyProfilerAllure": "3",
    "beautyProfilerProducts": "3,10,11,12,21,22,26,27,29,30,32,36,37,41"
  },
  {
    "id": "20",
    "label": "Picnic in golden sunlight",
    "description": "",
    "beautyProfilerAllure": "4",
    "beautyProfilerProducts": "3,4,6,9,10,11,12,21,22,26,27,29,38,41"
  },
  {
    "id": "21",
    "label": "Make a statement",
    "description": "",
    "beautyProfilerAllure": "1",
    "beautyProfilerProducts": "1,2,3,5,8,13,14,16,19,20,23,24,25,28,31,33,34,35,39,40"
  },
  {
    "id": "22",
    "label": "Quiet confidence",
    "description": "",
    "beautyProfilerAllure": "2",
    "beautyProfilerProducts": "1,2,4,6,7,11,13,15,21,22,23,26,29,30,32,36,37,38,41"
  },
  {
    "id": "23",
    "label": "Break the rules",
    "description": "",
    "beautyProfilerAllure": "3",
    "beautyProfilerProducts": "3,5,8,16,17,18,19,24,28,35,39"
  },
  {
    "id": "24",
    "label": "Natural glow",
    "description": "",
    "beautyProfilerAllure": "4",
    "beautyProfilerProducts": "4,6,9,10,11,12,14,21,22,26,27,29,38,41"
  },
  {
    "id": "25",
    "label": "Galerie Véro-Dodat",
    "description": "Luxury shopping",
    "beautyProfilerAllure": "1",
    "beautyProfilerProducts": "1,2,3,5,6,7,11,13,19,20,21,22,25,30,34,35,36,37,38,40"
  },
  {
    "id": "26",
    "label": "Palais Garnier",
    "description": "Cultural venue",
    "beautyProfilerAllure": "2",
    "beautyProfilerProducts": "2,4,6,7,9,11,13,15,20,21,22,23,24,25,26,27,29,30,32,33,34,35,37,38,39,40"
  },
  {
    "id": "27",
    "label": "Moulin Rouge",
    "description": "Endless night",
    "beautyProfilerAllure": "3",
    "beautyProfilerProducts": "1,3,5,8,14,16,17,18,19,20,23,24,25,28,31,33,34,39,40"
  },
  {
    "id": "28",
    "label": "Jardin des Tuileries",
    "description": "Romantic nature",
    "beautyProfilerAllure": "4",
    "beautyProfilerProducts": "1,4,6,7,9,10,11,12,21,22,26,27,29,30,32,36,37,38,41"
  },
  {
    "id": "29",
    "label": "A glass of wine",
    "description": "",
    "beautyProfilerAllure": "1",
    "beautyProfilerProducts": "1,2,4,5,6,7,8,14,15,16,17,18,19"
  },
  {
    "id": "30",
    "label": "A fancy cocktail",
    "description": "",
    "beautyProfilerAllure": "2",
    "beautyProfilerProducts": "3,6,9,12,13"
  },
  {
    "id": "31",
    "label": "A cup of tea",
    "description": "",
    "beautyProfilerAllure": "3",
    "beautyProfilerProducts": "4,5,8,10,11,14,15,16,17,18,19"
  },
  {
    "id": "32",
    "label": "A limonade",
    "description": "",
    "beautyProfilerAllure": "4",
    "beautyProfilerProducts": "3,5,9,10,11,12"
  },
  {
    "id": "33",
    "label": "Woody chypre",
    "description": "",
    "beautyProfilerAllure": "1",
    "beautyProfilerProducts": "2,3,4,5,6,7,8,14,15,16,17,18,19"
  },
  {
    "id": "34",
    "label": "Floral fresh",
    "description": "",
    "beautyProfilerAllure": "2",
    "beautyProfilerProducts": "3,6,9,10,11,12,17"
  },
  {
    "id": "35",
    "label": "Leather spicy",
    "description": "",
    "beautyProfilerAllure": "3",
    "beautyProfilerProducts": "1,5,8,9,10,11,13,15,16,17,18,19"
  },
  {
    "id": "36",
    "label": "Ambery fruity",
    "description": "",
    "beautyProfilerAllure": "4",
    "beautyProfilerProducts": "1,2,4,7,9,10,11,12,13,14,19"
  },
  {
    "id": "37",
    "label": "Tasty coffee ending",
    "description": "",
    "beautyProfilerAllure": "1",
    "beautyProfilerProducts": "2,3,4,5,6,8,9,13,14,15,16,17,18,19"
  },
  {
    "id": "38",
    "label": "Floral pastry",
    "description": "",
    "beautyProfilerAllure": "2",
    "beautyProfilerProducts": "3,9,10,11,12,13"
  },
  {
    "id": "39",
    "label": "Salted caramel",
    "description": "",
    "beautyProfilerAllure": "3",
    "beautyProfilerProducts": "2,4,5,6,9,12,15,19"
  },
  {
    "id": "40",
    "label": "Fruit tart",
    "description": "",
    "beautyProfilerAllure": "4",
    "beautyProfilerProducts": "1,10,11"
  },
  {
    "id": "41",
    "label": "Me",
    "description": "",
    "beautyProfilerAllure": "",
    "beautyProfilerProducts": ""
  },
  {
    "id": "42",
    "label": "It's a gift",
    "description": "",
    "beautyProfilerAllure": "",
    "beautyProfilerProducts": ""
  },
  {
    "id": "43",
    "label": "Empowered",
    "description": "",
    "beautyProfilerAllure": "",
    "beautyProfilerProducts": ""
  },
  {
    "id": "44",
    "label": "Elegant",
    "description": "",
    "beautyProfilerAllure": "",
    "beautyProfilerProducts": ""
  },
  {
    "id": "45",
    "label": "Audacious",
    "description": "",
    "beautyProfilerAllure": "",
    "beautyProfilerProducts": ""
  },
  {
    "id": "46",
    "label": "Radiant",
    "description": "",
    "beautyProfilerAllure": "",
    "beautyProfilerProducts": ""
  },
  {
    "id": "47",
    "label": "Floral",
    "description": "Rose, lavender, jasmin, …",
    "beautyProfilerAllure": "",
    "beautyProfilerProducts": ""
  },
  {
    "id": "48",
    "label": "Ambery & Fruity",
    "description": "Tonka bean, cherry, fig, …",
    "beautyProfilerAllure": "",
    "beautyProfilerProducts": ""
  },
  {
    "id": "49",
    "label": "Woody & Chypre",
    "description": "Oud, santal, patchouli, …",
    "beautyProfilerAllure": "",
    "beautyProfilerProducts": ""
  },
  {
    "id": "50",
    "label": "Leather & Spicy",
    "description": "Incense, pepper, suede, …",
    "beautyProfilerAllure": "",
    "beautyProfilerProducts": ""
  },
  {
    "id": "51",
    "label": "1",
    "description": "",
    "beautyProfilerAllure": "",
    "beautyProfilerProducts": ""
  },
  {
    "id": "52",
    "label": "2",
    "description": "",
    "beautyProfilerAllure": "",
    "beautyProfilerProducts": ""
  },
  {
    "id": "53",
    "label": "3",
    "description": "",
    "beautyProfilerAllure": "",
    "beautyProfilerProducts": ""
  },
  {
    "id": "54",
    "label": "4",
    "description": "",
    "beautyProfilerAllure": "",
    "beautyProfilerProducts": ""
  }
];
